window.SMTX.Hero = (function () {

  if ($('.hero-module').length < 1) {
    return false;
  }
  
  if($('.logo-banner').length > 0) {

    function initSlick() {
      $('.logo-banner').slick({
        centerMode: false,
        accessibility: false, 
        slidesToShow: 7,
        slidesToScroll: 1,
        speed: 3500,
        arrows: false,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 0,
        draggable: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              
              slidesToShow: 5
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      });
    }

    initSlick();
      
    var resizeTimer;
    $(window).resize(() => {
      // Debounce resize event
      $('.logo-banner').slick('unslick');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initSlick();
        $('.logo-banner').slick('resize');
        $('.logo-banner').slick('setPosition');
      }, 200);
    });
  }
})();
